const Line = ({ width }) => {
  return (
    <div className="w-100 d-flex flex-row justify-content-start align-items-center">
      <span className="bg-success" style={{ height: "5px" }} id="progress-bar" />
    </div>
  );
};

export default Line;
